import board from './utility/Board';
import AppAgGrid from './ag-grid/View';
import text from './text/Text';
import { AgGridVue } from 'ag-grid-vue';
import pagination from '@/components/pagination/View.vue'

$vue.component('app-board', board);
$vue.component('app-ag-grid', AppAgGrid);
$vue.component('ag-grid-vue', AgGridVue);
$vue.component('pagination', pagination);
$vue.component('t-text', text);
